import { render, staticRenderFns } from "./SingleLabelling.vue?vue&type=template&id=bb297008&scoped=true&"
import script from "./SingleLabelling.vue?vue&type=script&lang=ts&"
export * from "./SingleLabelling.vue?vue&type=script&lang=ts&"
import style0 from "./SingleLabelling.vue?vue&type=style&index=0&id=bb297008&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb297008",
  null
  
)

export default component.exports